import { render, staticRenderFns } from "./PlusQuickButtons.vue?vue&type=template&id=1a5af963&"
import script from "./PlusQuickButtons.vue?vue&type=script&lang=js&"
export * from "./PlusQuickButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a5af963')) {
      api.createRecord('1a5af963', component.options)
    } else {
      api.reload('1a5af963', component.options)
    }
    module.hot.accept("./PlusQuickButtons.vue?vue&type=template&id=1a5af963&", function () {
      api.rerender('1a5af963', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/sitecontent/PlusQuickButtons.vue"
export default component.exports